import { render, staticRenderFns } from "./Comparison.vue?vue&type=template&id=e094da04&scoped=true&"
import script from "./Comparison.vue?vue&type=script&lang=ts&"
export * from "./Comparison.vue?vue&type=script&lang=ts&"
import style0 from "./Comparison.vue?vue&type=style&index=0&id=e094da04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e094da04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
